module.exports = __webpack_public_path__ + "img/option1-active.19109b31.webp";